const newsList = document.querySelector('.news-list');

if (newsList) {
  // Filter and Pagination via ajax
  const axiosGetNewsList = async (parent, slug, pageNumber) => {
    const action = parent.querySelector('[data-action]').value;
    const listInner = parent.querySelector('.news-list__inner');
    const newsListFooter = parent.querySelector('.news-list__footer');

    const formDataInput = {
      action,
      pageNumber,
      filteredCategory: slug,
      nonce: await getNonceForAction(action),
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      listInner.innerHTML = '';

      if (listInner && data.data.html_list) {
        listInner.innerHTML = data.data.html_list;
      }

      if (newsListFooter && data.data.html_pagination) {
        newsListFooter.innerHTML = data.data.html_pagination;
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['filteredCategory', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
      cardList.scrollIntoView();
    } catch (err) {
      console.error(err);
    }
  };

  // Filter click
  attachEvent('.news-list .news-list__filter-button', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.news-list');
    const dataSlug = ev.target.getAttribute('data-slug');

    parent.querySelector('.news-list__filter-button.is-active').classList.remove('is-active');
    ev.target.classList.add('is-active');

    axiosGetNewsList(parent, dataSlug, 1);
  });

  // Pagination
  attachEvent('.news-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.news-list');
    const activeCategory = parent.querySelector('.news-list__filter-button.is-active');
    const dataSlug = activeCategory?.getAttribute('data-slug');
    const pageNumber = ev.target.dataset.page;

    axiosGetNewsList(parent, dataSlug, pageNumber);
  });
}
